import data from '../store/data'
import { isCustomProduct, state } from '../store/state'
import triggers from '../store/triggers'
import archive from '../store/archive'
import elements from '../store/elements'
import { handleize } from '../../../js/helpers/handleize'
import textCapitalize from '../../../js/helpers/text.capitalize'

const customTemplate = window.custom_template
const url = new URL(window.location.href)
let urlFormat = ''

const setLayoutAndTypeForCustomProducts = (value) => {
  const [type, layout] = value.split(' - ')
  state.type = type
  state.layout = customTemplate === 'basic' ? layout : value
  archive.layouts[type] = state.layout // add layout to archive
  triggers.emitEvent('state:type', [type])
  triggers.emitEvent('state:layout', [state.layout])
}

const setOptionsToState = (variant) => {
  for (let i = 0; i < data.options.length; i++) {
    const option = data.options[i]
    const optionKey = `option${i + 1}`

    // Get type from layout for basic and frames custom products
    if (
      option === 'layout' &&
      isCustomProduct &&
      (customTemplate === 'basic' || customTemplate === 'frames')
    ) {
      setLayoutAndTypeForCustomProducts(variant[optionKey])
    } else {
      // don't set size if product is not custom and if product is not loaded with variant id
      if (!isCustomProduct && option === 'size' && urlFormat.length === 0) {
        continue
      }

      state[option] = variant[optionKey]
      // add to archives
      switch (option) {
        case 'size':
          archive.sizes[state.layout] = variant[optionKey]
          break
        case 'depth':
          archive.depths[`${state.layout} + ${state.size}`] = variant[optionKey]
          break
        case 'color':
          archive.colors[state.layout] = variant[optionKey]
          break
      }
      triggers.emitEvent(`state:${option}`, [variant[optionKey]])
    }
  }
}

const getDataFromURL = () => {
  // if URL contains variant
  if (url.searchParams.has('variant')) {
    urlFormat = 'variants'
    const idFromURL = +url.searchParams.get('variant')
    for (const variant of data.variants) {
      if (variant.id === idFromURL) {
        setOptionsToState(variant)
        break
      }
    }
  // if URL contains options
  } else {
    // for (const option of data.options) {
    //   if (url.searchParams.has(option)) {
    //     const value = url.searchParams.get(option)
    //     if (option === 'layout' &&
    //       isCustomProduct &&
    //       (customTemplate === 'basic' || customTemplate === 'frames')
    //     ) {
    //       setLayoutAndTypeForCustomProducts(value)
    //     } else {
    //       if (option === 'size') {
    //         archive.sizes[state.layout] = value // add size to archive
    //       }
    //       state[option] = value
    //       triggers.emitEvent(`state:${option}`, [value])
    //       urlFormat = 'options'
    //     }
    //   }
    // }

    // layout
    if (url.searchParams.has('layout')) {
      let layout = url.searchParams.get('layout')
      if (isCustomProduct && (customTemplate === 'basic' || customTemplate === 'frames')) {
        const type = textCapitalize(layout.substring(0, layout.indexOf('-')), ' ')
        layout = customTemplate === 'basic'
          ? textCapitalize(layout.substring(layout.indexOf('-') + 1).replace(/-/g, ' '), ' ')
          : textCapitalize(`${type} - ${layout.substring(layout.indexOf('-') + 1).replace(/-/g, ' ')}`, ' ')
        state.type = type
        archive.layouts[type] = layout
        triggers.emitEvent('state:type', [type])
      } else {
        layout = textCapitalize(layout.replace(/-/g, ' '), ' ')
      }
      state.layout = layout
      triggers.emitEvent('state:layout', [layout])
      urlFormat = 'options'
    }
    // size
    if (url.searchParams.has('size') && state.layout) {
      const size = url.searchParams.get('size').replace(/X/i, '" X ') + '"'
      state.size = size
      archive.sizes[state.layout] = size
      triggers.emitEvent('state:size', [size])
      urlFormat = 'options'
    }
    // depth
    if (url.searchParams.has('depth') && state.layout && state.size) {
      const depth = url.searchParams.get('depth') + '"'
      state.depth = depth
      archive.depths[`${state.layout} + ${state.size}`] = depth
      triggers.emitEvent('state:depth', [depth])
      urlFormat = 'options'
    }
    // color
    if (url.searchParams.has('color') && state.layout) {
      const color = textCapitalize(url.searchParams.get('color'), ' ')
      state.color = color
      archive.colors[state.layout] = color
      triggers.emitEvent('state:color', [color])
      urlFormat = 'options'
    }
    // amount
    if (url.searchParams.has('amount')) {
      const amount = `$${url.searchParams.get('amount')}`
      for (let i = 0; i < elements.amounts.length; i++) {
        if (elements.amounts[i].dataset.avalue === amount) {
          state.imgIndex = i
          triggers.emitEvent('state:imgIndex', [i])
          break
        }
      }
      urlFormat = 'options'
    }
  }

  // fallback. for case when product URL without search params
  if (urlFormat.length < 1) {
    const variant = data.variants[0] // get first variant
    setOptionsToState(variant)
    urlFormat = 'options'
  }
}

const setVariantIdToURL = (variant) => {
  if (!variant) return
  url.searchParams.set('variant', variant.id)
  window.history.replaceState(null, '', url.href)
}

const setOptionsToURL = () => {
  const paramsBefore = url.searchParams.toString()

  // layout
  if (state.layout) {
    url.searchParams.set('layout', handleize(isCustomProduct && customTemplate === 'basic' ? `${state.type} - ${state.layout}` : state.layout))
  } else {
    url.searchParams.delete('layout')
  }

  // size
  if (state.size) {
    url.searchParams.set('size', handleize(state.size).replace(/-/g, ''))
  } else {
    url.searchParams.delete('size')
  }

  // color / amount
  for (const key of ['color', 'amount']) {
    if (state[key]) {
      url.searchParams.set(key, handleize(state[key]))
    } else {
      url.searchParams.delete(key)
    }
  }

  // depth
  if (state.depth) {
    url.searchParams.set('depth', state.depth.replace('"', ''))
  } else {
    url.searchParams.delete('depth')
  }

  // url.searchParams.sort()
  const paramsAfter = url.searchParams.toString()

  paramsAfter !== paramsBefore &&
  window.history.replaceState(null, '', url.href)
}

const history = () => {
  getDataFromURL()

  // update URL
  triggers.on('state:variant', (urlFormat === 'variants' ? setVariantIdToURL : setOptionsToURL))
}

export default history
